export default "__VITE_ASSET___4H0YCxK__"